"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var OnClickOutside = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(OnClickOutside, _React$PureComponent);

  var _super = _createSuper(OnClickOutside);

  function OnClickOutside(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, OnClickOutside);
    _this = _super.call(this, props);
    _this.wrapperRef = /*#__PURE__*/_react["default"].createRef();
    _this.onClickOutside = _this.onClickOutside.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(OnClickOutside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('mousedown', this.onClickOutside, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this.onClickOutside, true);
    }
  }, {
    key: "onClickOutside",
    value: function onClickOutside(e) {
      var current = this.wrapperRef.current;
      var onClickOutside = this.props.onClickOutside;

      if (current && !current.contains(e.target)) {
        onClickOutside(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className;
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.wrapperRef,
        className: className
      }, children);
    }
  }]);
  return OnClickOutside;
}(_react["default"].PureComponent);

OnClickOutside.defaultProps = {
  className: ''
};
OnClickOutside.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  onClickOutside: _propTypes["default"].func.isRequired
};
var _default = OnClickOutside;
exports["default"] = _default;